export default {"src":"/_next/static/media/but.cb890f54.svg","height":80,"width":78};